import { redirect } from "react-router";
import { styled } from "styled-system/jsx";

import { Button } from "~/components/Button/Button.tsx";
import { Card } from "~/components/Card/Card.tsx";
import { authClient } from "~/services/auth.client.ts";
import { auth, isGithubLoginConfigured } from "~/services/auth.server.ts";
import { dashboardUrl } from "~/utils/route/urls.ts";

import type { Route } from "./+types/route";

export async function loader({ request }: Route.LoaderArgs) {
	const session = await auth.api.getSession({ headers: request.headers });

	if (session) {
		throw redirect(dashboardUrl());
	}

	return { githubEnabled: isGithubLoginConfigured };
}

const Page = styled("main", {
	base: {
		minHeight: "100vh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: "gray.50",
	},
});

const Title = styled("h1", {
	base: {
		fontSize: "xl",
		fontWeight: "semibold",
		marginBottom: "2",
	},
});

const Subtitle = styled("p", {
	base: {
		color: "gray.600",
		fontSize: "sm",
		marginBottom: "6",
	},
});

export default function Login({ loaderData }: Route.ComponentProps) {
	const { githubEnabled } = loaderData;

	return (
		<Page>
			<Card minWidth="sm" textAlign="center">
				<Title>Clearfor</Title>
				<Subtitle>Spec-driven development for teams</Subtitle>
				{githubEnabled ? (
					<Button
						type="button"
						onClick={() => authClient.signIn.social({ provider: "github", callbackURL: dashboardUrl() })}
					>
						Continue with GitHub
					</Button>
				) : (
					<Subtitle>
						GitHub login is not configured. Set GITHUB_CLIENT_ID and GITHUB_CLIENT_SECRET in services/app/.env.
					</Subtitle>
				)}
			</Card>
		</Page>
	);
}
